import React, { useEffect } from 'react';
import useToolStore, { TOOL_TYPES } from '../../../store/useToolStore';
import { generateCode } from '../../../utils/codeGenerators';

const ShadowGenerator = () => {
  const config = useToolStore((state) => state.toolConfigs[TOOL_TYPES.SHADOW]);
  const updateConfig = useToolStore((state) => state.updateToolConfig);
  const setGeneratedCode = useToolStore((state) => state.setGeneratedCode);

  useEffect(() => {
    const code = generateCode(TOOL_TYPES.SHADOW, config);
    setGeneratedCode(code);
  }, [config, setGeneratedCode]);

  const set = (patch) => updateConfig(TOOL_TYPES.SHADOW, patch);

  return (
    <div className="p-6">
      <h2 className="text-xl font-bold mb-4 text-gray-900 dark:text-white">Shadow Generator</h2>

      <div className="space-y-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <label className="block">
            <div className="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-1">Color</div>
            <input
              type="color"
              value={config.color}
              onChange={(e) => set({ color: e.target.value })}
              className="h-10 w-full rounded-md border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800"
            />
          </label>

          <label className="block">
            <div className="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-1">
              Opacity ({config.opacity})
            </div>
            <input
              type="range"
              min="0"
              max="1"
              step="0.01"
              value={config.opacity}
              onChange={(e) => set({ opacity: Number(e.target.value) })}
              className="w-full"
            />
          </label>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
          <label className="block">
            <div className="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-1">Radius</div>
            <input
              type="number"
              value={config.radius}
              onChange={(e) => set({ radius: Number(e.target.value) })}
              className="w-full px-3 py-2 rounded-md border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 text-gray-900 dark:text-white"
            />
          </label>
          <label className="block">
            <div className="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-1">X</div>
            <input
              type="number"
              value={config.x}
              onChange={(e) => set({ x: Number(e.target.value) })}
              className="w-full px-3 py-2 rounded-md border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 text-gray-900 dark:text-white"
            />
          </label>
          <label className="block">
            <div className="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-1">Y</div>
            <input
              type="number"
              value={config.y}
              onChange={(e) => set({ y: Number(e.target.value) })}
              className="w-full px-3 py-2 rounded-md border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 text-gray-900 dark:text-white"
            />
          </label>
        </div>
      </div>
    </div>
  );
};

export const ShadowPreviewComponent = () => {
  const config = useToolStore((state) => state.toolConfigs[TOOL_TYPES.SHADOW]);
  const shadowStyle = {
    boxShadow: `${config.x}px ${config.y}px ${Math.max(0, config.radius)}px rgba(0,0,0,${config.opacity})`,
  };

  return (
    <div className="h-full w-full flex items-center justify-center bg-gray-50 dark:bg-gray-900">
      <div
        className="w-56 h-36 rounded-2xl bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 flex items-center justify-center text-gray-900 dark:text-white"
        style={shadowStyle}
      >
        Preview
      </div>
    </div>
  );
};

export default ShadowGenerator;

